/**
 * Detect whether the browser is honouring our httpOnly session cookie.
 * If not, we're relying only on the in-memory Bearer token — which means
 * a refresh or a new tab will log the user out. We surface this via a banner.
 *
 * Detection strategy: hit /auth/me with credentials but explicitly NO Bearer.
 * If we get 401, the cookie was dropped. If 200, cookies are working.
 */
import { API_BASE } from "./api";

let _cookiesBlocked = false;
const listeners = new Set();

export const isCookiesBlocked = () => _cookiesBlocked;

export const onCookieStatusChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const setBlocked = (v) => {
  if (_cookiesBlocked === v) return;
  _cookiesBlocked = v;
  listeners.forEach((fn) => fn(v));
};

export const probeCookieAuth = async () => {
  try {
    // Use raw fetch (not the axios instance) so no Authorization is injected.
    const resp = await fetch(`${API_BASE}/auth/me`, {
      method: "GET",
      credentials: "include",
      // Explicitly no Authorization header
    });
    setBlocked(resp.status === 401);
    return resp.status !== 401;
  } catch {
    // Network error: don't scare the user, keep prior state
    return !_cookiesBlocked;
  }
};

export const resetCookieProbe = () => setBlocked(false);
